import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { UserType } from '../../interfaces/userType.enum';
import StoreAdminDashboard from './StoreAdminDashboard';
import UserDashboardView from './UserDashboardView';
import DashboardBoard from './board/DashboardBoard';
import PosDashboardTiles from '../pos/PosDashboardTiles';

const Dashboard: React.FC = () => {
    const { user } = useAuth();

    const userRoles = user && user.roles ? (Array.isArray(user.roles) ? user.roles : [user.roles]) : [];
    const hasRole = (role: UserType) => userRoles.includes(role);

    const isSystemAdmin = hasRole(UserType.SystemAdmin);
    const isInstitutionAdmin = hasRole(UserType.InstitutionAdmin);
    const isInstitutionManager = hasRole(UserType.InstitutionManager);
    const isStoreAdmin = hasRole(UserType.StoreAdmin);
    const isStoreManager = hasRole(UserType.StoreManager);
    const isAccountant = hasRole(UserType.Accountant);

    if (isSystemAdmin) {
        return (
            <Box sx={{ p: 2 }}>
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Dashboard
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                    Welcome, System Administrator
                </Typography>
                <Link to="/institutions" style={{ textDecoration: 'none' }}>
                    <Typography color="primary">Manage Institutions</Typography>
                </Link>
            </Box>
        );
    }

    if (isInstitutionAdmin || isInstitutionManager || isAccountant) {
        return (
            <>
                <PosDashboardTiles />
                <DashboardBoard />
            </>
        );
    }

    if (isStoreAdmin || isStoreManager) {
        return (
            <>
                <PosDashboardTiles />
                <StoreAdminDashboard />
            </>
        );
    }

    return <UserDashboardView />;
};

export default Dashboard;
